import catalog from "./generated/catalog.json";

export const LOCALE_STORAGE_KEY = "10k.localization.locale";

export const SUPPORTED_LOCALES = Object.freeze([...catalog.localeOrder]);

export const LOCALE_DETAILS = Object.freeze([
  { locale: "en", nativeName: "English", englishName: "English", isRtl: false },
  { locale: "es-419", nativeName: "Español (Latinoamérica)", englishName: "Spanish", isRtl: false },
  { locale: "ar", nativeName: "العربية", englishName: "Arabic", isRtl: true },
  { locale: "zh-CN", nativeName: "简体中文", englishName: "Chinese (Simplified)", isRtl: false },
  { locale: "vi", nativeName: "Tiếng Việt", englishName: "Vietnamese", isRtl: false },
  { locale: "pt-BR", nativeName: "Português (Brasil)", englishName: "Portuguese", isRtl: false },
  { locale: "tr", nativeName: "Türkçe", englishName: "Turkish", isRtl: false },
  { locale: "fr", nativeName: "Français", englishName: "French", isRtl: false },
  { locale: "it", nativeName: "Italiano", englishName: "Italian", isRtl: false },
  { locale: "de", nativeName: "Deutsch", englishName: "German", isRtl: false },
  { locale: "ru", nativeName: "Русский", englishName: "Russian", isRtl: false },
  { locale: "hi", nativeName: "हिन्दी", englishName: "Hindi", isRtl: false },
]);

export const findSupportedLocale = (value) => {
  const normalized = String(value ?? "").trim().replaceAll("_", "-").toLowerCase();
  if (!normalized) return null;
  if (normalized === "en" || normalized.startsWith("en-")) return "en";
  if (normalized === "es" || normalized.startsWith("es-")) return "es-419";
  if (normalized === "ar" || normalized.startsWith("ar-")) return "ar";
  if (normalized === "zh" || normalized === "zh-cn" || normalized === "zh-hans" || normalized.startsWith("zh-hans-")) return "zh-CN";
  if (normalized === "vi" || normalized.startsWith("vi-")) return "vi";
  if (normalized === "pt" || normalized === "pt-br" || normalized.startsWith("pt-br-")) return "pt-BR";
  if (normalized === "tr" || normalized.startsWith("tr-")) return "tr";
  if (normalized === "fr" || normalized.startsWith("fr-")) return "fr";
  if (normalized === "it" || normalized.startsWith("it-")) return "it";
  if (normalized === "de" || normalized.startsWith("de-")) return "de";
  if (normalized === "ru" || normalized.startsWith("ru-")) return "ru";
  if (normalized === "hi" || normalized.startsWith("hi-")) return "hi";
  return null;
};

export const normalizeLocale = (value) => findSupportedLocale(value) ?? "en";

export const getLocaleDetails = (locale) =>
  LOCALE_DETAILS.find((candidate) => candidate.locale === normalizeLocale(locale)) ?? LOCALE_DETAILS[0];

export const getInitialBrowserLocale = () => {
  try {
    const saved = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    const supportedSaved = findSupportedLocale(saved);
    if (supportedSaved) return supportedSaved;
  } catch {
    // Storage can be unavailable in privacy-restricted embeds.
  }
  const candidates = typeof navigator === "undefined" ? [] : navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const candidate of candidates) {
    const supported = findSupportedLocale(candidate);
    if (supported) return supported;
  }
  return "en";
};

export const translateCatalog = (locale, key, params = {}) => {
  const normalized = normalizeLocale(locale);
  const value = catalog.locales[normalized]?.[key] ?? catalog.locales.en?.[key] ?? "";
  if (!value && process.env.NODE_ENV !== "production") {
    console.warn(`Missing localization key: ${key}`);
  }
  return String(value).replace(/\{([^{}]+)\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match,
  );
};

export { catalog };
